// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Header_mainHeading__2Psmg","text":"Header_text__1nCwc","textFirst":"Header_textFirst__19iBK"};